import { CardContent, IconButton } from '@material-ui/core'
import React, { Component } from 'react'
import { Card } from 'react-bootstrap'
import CancelIcon from '@material-ui/icons/Cancel'

class DialogoPenalizacionCamion extends Component {
  render () {
    const { camion, motivo, vencimiento, handleClose } = this.props

    return (
      <div>
        <Card style={{ border: 'none' }}>
          <Card.Header style={{ backgroundColor: '#3f51b5', color: '#ffffff' }}>
            <IconButton onClick={handleClose} style={{ margin: '0', padding: '0', float: 'right' }}>
              <CancelIcon style={{ color: '#ffffff' }} />
            </IconButton>
          </Card.Header>
          <CardContent style={{ width: '85%', margin: '0 auto', textAlign: 'center' }}>
            <h4>La patente <strong>{camion}</strong> se encuentra penalizada por {motivo.toLocaleLowerCase()}.</h4>
            <br />
            <h4>No puede egresar de la playa hasta el <strong>{vencimiento}</strong></h4>
          </CardContent>
        </Card>
      </div>
    )
  }
}

export default DialogoPenalizacionCamion
